import ajaxHandler from '../util/ajaxLoadMore';
import newsListing from '../layout/news-listing';

export default {
  init() {
    newsListing();
  },
  finalize() {
    ajaxHandler(
      '.btn-load-more-posts',
      '.posts-listing',
      window.binah_data_news_n_resources
    );
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/news.js